module.exports = __webpack_public_path__ + "static/img/1233.4c2535e9.png";